import { render, staticRenderFns } from "./CreateTaskModal.vue?vue&type=template&id=83bb2f94&scoped=true&"
import script from "./CreateTaskModal.vue?vue&type=script&lang=js&"
export * from "./CreateTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaskModal.vue?vue&type=style&index=0&id=83bb2f94&prod&lang=less&scoped=true&"
import style1 from "./CreateTaskModal.vue?vue&type=style&index=1&id=83bb2f94&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bb2f94",
  null
  
)

export default component.exports